// extracted by css-extract-rspack-plugin
export default {"root":"TableInteractive-module__root___D3hkn","pivotedFirstColumn":"TableInteractive-module__pivotedFirstColumn___Ov8ag"};